import { Auth as Cognito } from '@aws-amplify/auth';
import axios from 'axios';

export class SignApi {
    async fetchSignedCookie() {
        return axios.get('/cookie', {
            withCredentials: true,
            headers: {
                Authorization: `Bearer ${(await Cognito.currentSession()).getIdToken().getJwtToken()}`,
            },
        });
    }
}

export const signApi = new SignApi();
